

























































import { Row, Col, Swipe, SwipeItem } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { wxChatShare } from "@/common/wechat";
import request from "@/api/index";
import Openapp from "@/components/openApp.vue";
import native from "@/common/Native";
import ImageViewComMu from "@/components/imageViewComMu.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    Openapp,
    ImageViewComMu
  }
})
export default class NewsMultiple extends Vue {
  public request = new request();
  private imgList: Array<object> = [];
  private imgInfo: object | any = {};
  private id: string = "";
  private appId: string = "";
  private current: string = "";
  private bg: string = "0.5";
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  vfrom: string = ""; //是否预览
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.id = this.$route.query.id as string;
    this.appId = this.$route.query.appId as string;
    this.vfrom = (this.$route.query.vfrom as string) || "";
    console.log(this.appId);
    this.getImgList();
    this.getCount();
    //九龙坡 预览新闻时, 底部评论和顶部分享不显示
    if (this.vfrom && ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "",
        isShowMoreBtn: "0"
      });
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
    }
    if (ZWY_CLOUD.isOpenInApp()) {
      // get用户信息
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getBussinessDetail();
      });
    } else {
      this.getBussinessDetail();
    }
  }
  onChange(index: string) {
    this.current = index;
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  // 获取多图列表
  getImgList() {
    return this.request.getList(this.id).then(res => {
      if (res.code === 0) {
        this.imgInfo = res.data;
        document.title = this.imgInfo.title;
        this.imgList = this.imgInfo.appResource;
        this.appId = this.imgInfo.appId;
        this.$store.commit("SET_STATE", {
          appId: this.appId
        });
        const el = this.$refs.ImageViewCom as any;
        el.openView(0);
        this.$nextTick(() => {
          // 埋点
          this.endTime = time();
          if (this.dataSource) {
            getData(this.startTime, this.endTime, this.imgInfo);
            this.dataSource = false;
          }
        });
      }
    });
  }
  // 业务详情
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        this.id,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  // 浏览量
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.id);
    }
  }
}
